import { render } from "./Custom-table.vue?vue&type=template&id=6d466872"
import script from "./Custom-table.vue?vue&type=script&lang=js"
export * from "./Custom-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__